'use strict';

/**
 * Theme-specific VUGRON functions for Muziekschool V2
 * Registration form handling
 */

// eslint-disable-next-line no-redeclare
var VUGRON = VUGRON || {};
VUGRON.Muziekschool_V2 = VUGRON.Muziekschool_V2 || {};

/**
 * Registration Form Module
 * Handles birth date validation, error banners, and radio selection display
 */
VUGRON.Muziekschool_V2.RegistrationForm = (function() {

    /**
     * Hide error banners when user changes selection
     */
    function hideErrorBanners() {
        ['form-message-banner', 'form-message-banner-top'].forEach(function(id) {
            var banner = document.getElementById(id);
            if (banner) banner.style.display = 'none';
        });
    }

    /**
     * Handle missing birth date validation block
     * Shows/hides the block based on selected registration option
     * Reads age limits from data-attributes on the block element
     *
     * NOTE: DOM elements are queried fresh each time because update_schedule()
     * replaces the entire #schedule HTML, making cached references stale.
     */
    function updateMissingBirthDateBlock(clickedRadio) {
        var block = document.getElementById('missing-birth-date-block');
        if (!block) return;

        var messageEl = document.getElementById('missing-birth-date-message');
        var inputEl = document.getElementById('new_birth_date');
        var ageMin = parseInt(block.getAttribute('data-age-min') || '0', 10);
        var ageMax = parseInt(block.getAttribute('data-age-max') || '99', 10);

        // Use clicked radio if provided, otherwise get currently checked
        var selectedRadio = clickedRadio || document.querySelector('input[name="who"]:checked');
        if (!selectedRadio) {
            block.style.display = 'none';
            if (inputEl) inputEl.removeAttribute('required');
            return;
        }

        // If clicked radio is disabled, hide the block
        if (selectedRadio.disabled) {
            block.style.display = 'none';
            if (inputEl) inputEl.removeAttribute('required');
            return;
        }

        var isMissingBirthDate = selectedRadio.getAttribute('data-missing-birth-date') === '1';
        var isSomeoneElse = selectedRadio.value === 'someone_else';

        if (isMissingBirthDate && !isSomeoneElse) {
            block.style.display = 'block';
            if (inputEl) inputEl.setAttribute('required', 'required');

            // Update message based on who is selected
            var childName = selectedRadio.getAttribute('data-child-name') || '';
            if (childName === 'jezelf') {
                messageEl.innerHTML = 'Deze cursus is voor de leeftijd ' + ageMin + '-' + ageMax + ' jaar. Vul je geboortedatum in zodat we kunnen controleren of je in aanmerking komt.';
            } else {
                messageEl.innerHTML = childName + ' heeft geen geboortedatum. Vul deze in zodat we kunnen controleren of de cursist in aanmerking komt voor deze cursus (' + ageMin + '-' + ageMax + ' jaar).';
            }
        } else {
            block.style.display = 'none';
            if (inputEl) inputEl.removeAttribute('required');
        }
    }

    function initMissingBirthDateHandler() {
        // Initial state
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() { updateMissingBirthDateBlock(); });
        } else {
            updateMissingBirthDateBlock();
        }

        // Handle enabled radio buttons (event delegation survives DOM replacement)
        document.addEventListener('change', function(e) {
            if (e.target.name === 'who') {
                updateMissingBirthDateBlock();
                hideErrorBanners();
            }
        });

        // Handle disabled radio buttons (click on label, change event doesn't fire for disabled)
        document.addEventListener('click', function(e) {
            var label = e.target.closest('label.radio-select');
            if (label) {
                var radio = label.querySelector('input[name="who"]');
                if (radio && radio.disabled) {
                    updateMissingBirthDateBlock(radio);
                    hideErrorBanners();
                }
            }
        });
    }

    /**
     * Initialize error banner hiding on selection change
     * This runs even when there's no missing birth date block
     */
    function initErrorBannerHandler() {
        // For enabled radio buttons
        document.addEventListener('change', function(e) {
            if (e.target.name === 'who') {
                hideErrorBanners();
            }
        });

        // For disabled radio buttons (click on label)
        document.addEventListener('click', function(e) {
            var label = e.target.closest('label.radio-select');
            if (label) {
                var radio = label.querySelector('input[name="who"]');
                if (radio && radio.disabled) {
                    hideErrorBanners();
                }
            }
        });
    }

    /**
     * Update radio selection visual state
     * Adds 'is-selected' class to selected radio labels for checkmark styling
     */
    function initRadioSelectionDisplay() {
        // Only init if registration form exists
        if (!document.querySelector('.registration_single_step label.radio-select')) return;

        function updateRadioSelection() {
            document.querySelectorAll('.registration_single_step label.radio-select').forEach(function(label) {
                var input = label.querySelector('input[type="radio"]');
                if (input && input.checked) {
                    label.classList.add('is-selected');
                } else {
                    label.classList.remove('is-selected');
                }
            });
        }

        // Initial state
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateRadioSelection);
        } else {
            updateRadioSelection();
        }

        // Update on change
        document.addEventListener('change', function(e) {
            if (e.target.type === 'radio') updateRadioSelection();
        });
    }

    /**
     * Initialize all registration form handlers
     */
    function init() {
        initMissingBirthDateHandler();
        initErrorBannerHandler();
        initRadioSelectionDisplay();
    }

    // Public API
    return {
        init: init,
        hideErrorBanners: hideErrorBanners
    };

}());

/**
 * Initialize on DOM ready
 */
$(function() {
    // Always init datepickers when calc price form is loaded (i.e. course subscribe pages -> birthdate input)
    var form_calc_price = document.getElementById('calc_price');
    if (typeof form_calc_price !== 'undefined' && form_calc_price != null) {
        VUGRON.Main.set_datepickers();
    }

    // Init registration form handlers
    if (typeof VUGRON.Muziekschool_V2.RegistrationForm !== 'undefined') {
        VUGRON.Muziekschool_V2.RegistrationForm.init();
    }

    // Lesduren kunnen leeftijdsafhankelijk zijn (jongeren/volwassenen/beide): bij page-load 1x filteren
    // op de dan al bekende leeftijd (bijv. ingelogde cursist), net als de bestaande knipkaart-filtering.
    if (typeof VUGRON.Main.filterLessonDurationsByAge === 'function') {
        VUGRON.Main.filterLessonDurationsByAge($('input[name="who"]:checked').data('age'));
    }

    // Listen for birth_date changes in .not_me (iemand anders) - validate against course age limits
    $(document).on('change', '.not_me input[name="birth_date"]', function() {
        var birthDateVal = $(this).val();
        var $errorMessage = $('#age-error-message');
        var $errorText = $errorMessage.find('.error-text');
        var ageMin = parseInt($('#schedule').data('age_min')) || 0;
        var ageMax = parseInt($('#schedule').data('age_max')) || 99;
        var hasAgeLimits = (ageMin > 0 || ageMax < 99);

        if (birthDateVal && birthDateVal.match(/^\d{2}-\d{2}-\d{4}$/)) {
            var age = VUGRON.Main.calculateAge(birthDateVal, VUGRON.Main.getAgeReferenceDate());

            if (hasAgeLimits && !isNaN(age) && (age < ageMin || age > ageMax)) {
                var ageRange = ' (' + ageMin + '-' + ageMax + ' jaar)';
                $errorText.text('De ingevulde geboortedatum valt buiten de leeftijdsgroep' + ageRange + ' voor deze cursus.');
                $errorMessage.fadeIn(300);
            } else if (!isNaN(age)) {
                // Set birth_date on calc_price for "iemand anders"
                $('#calc_price').data('birth_date', birthDateVal);

                $errorMessage.fadeOut(300);
                VUGRON.Muziekschool_V2.RegistrationForm.hideErrorBanners();

                // Lesduren kunnen leeftijdsafhankelijk zijn (jongeren/volwassenen/beide): direct
                // (client-side) filteren zodat de juiste lesduren meteen getoond worden, niet pas na
                // een andere actie (bijv. wisselen van cursusduur). Zelfde patroon als bij knipkaarten.
                VUGRON.Main.filterLessonDurationsByAge(age);
                VUGRON.Main.calculate_price(birthDateVal);
            }
        }
    });

    // Listen for new_birth_date changes (missing birth date flow) - set on calc_price for price calculation
    $(document).on('change', '#new_birth_date', function() {
        var birthDateVal = $(this).val();
        var $errorMessage = $('#age-error-message');
        var $errorText = $errorMessage.find('.error-text');
        var isCustomer = $('input[name="who"]:checked').data('customer') === 1;
        var minDebtorAge = parseInt($('#schedule').data('min_debtor_age')) || 18;

        var ageMin = parseInt($('#schedule').data('age_min')) || 0;
        var ageMax = parseInt($('#schedule').data('age_max')) || 99;
        var hasAgeLimits = (ageMin > 0 || ageMax < 99);

        if (birthDateVal && birthDateVal.match(/^\d{2}-\d{2}-\d{4}$/)) {
            var age = VUGRON.Main.calculateAge(birthDateVal, VUGRON.Main.getAgeReferenceDate());

            if(isCustomer && !isNaN(age) && age < minDebtorAge) {
                if(!$("#form-message-banner").is(":visible")) {
                    $errorText.text('Als klant/betalingsplichte moet je minimaal ' + minDebtorAge + ' jaar zijn');
                    $errorMessage.fadeIn(300);
                }
            } else if (hasAgeLimits && !isNaN(age) && (age < ageMin || age > ageMax)) {
                if(!$("#form-message-banner").is(":visible")) {
                    var ageRange = ' (' + ageMin + '-' + ageMax + ' jaar)';
                    $errorText.text('De ingevulde geboortedatum valt buiten de leeftijdsgroep' + ageRange + ' voor deze cursus.');
                    $errorMessage.fadeIn(300);
                }
            } else if (!isNaN(age)) {
                // Set birth_date on calc_price for price calculation
                $('#calc_price').data('birth_date', birthDateVal);

                if(!$("#form-message-banner").is(":visible")) {
                    $errorMessage.fadeOut(300);
                }

                VUGRON.Muziekschool_V2.RegistrationForm.hideErrorBanners();

                // Lesduren kunnen leeftijdsafhankelijk zijn (jongeren/volwassenen/beide)
                VUGRON.Main.filterLessonDurationsByAge(age);

                // Recalculate price with new birth date
                VUGRON.Main.calculate_price(birthDateVal);
            }
        }
    });

    $(document).on('mouseenter', '.dropdown-toggle.hover', function() {
        $('.dropdown-menu.show').removeClass('show');

        if(this.id !== undefined) {
            $('div[aria-labelledby="' + this.id + '"]').addClass('show');
        }
    });

    $(document).on('mouseleave', '.dropdown-menu.js-showOnHover', function() {
        $(this).removeClass('show');
    });
});

